/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'

export const acceptInviteRequestV4Schema = z.object({
  token: z
    .string()
    .nullish()
    .describe('The raw token from the emailed link. Single-use, valid 24h.'),
  password: z
    .string()
    .nullish()
    .describe('Password the invitee chooses (min 8 chars, with upper, lower and a digit).'),
  passwordRepeat: z.string().nullish().describe('The password again — compared server-side.'),
  name: z.string().nullish().describe('First name. Required.'),
  lastName: z.string().nullish().describe('Last name. Required.'),
  phone: z.string().nullish().describe('Phone number. Optional.'),
})
